import VacancyCardWrapper from './VacancyCardWrapper.component';

export default VacancyCardWrapper;
